import type { RotateGizmo } from 'playcanvas';

type RotateGizmoShapeAxis = 'x' | 'y' | 'z' | 'xyz' | 'face';

type RotateGizmoShape = {
    entity?: { enabled: boolean };
    visible?: boolean;
    show?: (state: 'sector' | 'ring' | 'none') => void;
};

type RotateGizmoWithShapes = RotateGizmo & {
    _shapes?: Partial<Record<'x' | 'y' | 'z' | 'xyz' | 'f', RotateGizmoShape>>;
};

const AXIS_RING_TUBE_RADIUS = 0.018;
const AXIS_RING_HIT_TOLERANCE = 0.08;

function hideShape(gizmo: RotateGizmoWithShapes, axis: 'xyz' | 'f'): void {
    const shape = gizmo._shapes?.[axis];
    if (!shape) {
        return;
    }
    shape.show?.('none');
    shape.visible = false;
    if (shape.entity) {
        shape.entity.enabled = false;
    }
}

function configureAxisOnlyRotateGizmo(gizmo: RotateGizmo): void {
    // Only the red/green/blue axis ribbons should be visible and draggable.
    (['face', 'xyz'] as RotateGizmoShapeAxis[]).forEach((axis) => {
        gizmo.enableShape(axis, false);
    });

    const internalGizmo = gizmo as RotateGizmoWithShapes;
    hideShape(internalGizmo, 'f');
    hideShape(internalGizmo, 'xyz');

    gizmo.xyzTubeRadius = AXIS_RING_TUBE_RADIUS;
    gizmo.ringTolerance = AXIS_RING_HIT_TOLERANCE;
}

export { configureAxisOnlyRotateGizmo };
